/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FolderPlane140 = (props: SVGProps) => (
    <AccessibleSVG width={140} height={140} viewBox="0 0 140 140" {...props}>
        <g fill="none" fillRule="evenodd">
            <ellipse cx={70} cy={137} fill={vars.bdlBoxBlue} fillOpacity={0.07} rx={32.5} ry={3} />
            <path
                fill={vars.bdlBoxBlue}
                d="M2 83.5c.276 0 .5.215.5.49l.001.644c.151.088.278.214.365.366h.644a.5.5 0 01.482.412L4 85.5c0 .276-.215.5-.49.5l-.644.001a1.014 1.014 0 01-.365.365l-.001.644a.5.5 0 01-.412.482L2 87.5a.506.506 0 01-.5-.505v-.629a1.005 1.005 0 01-.366-.365L.49 86a.5.5 0 01-.482-.412L0 85.5c0-.276.215-.5.49-.5h.644c.088-.152.214-.278.366-.366v-.642a.5.5 0 01.412-.484L2 83.5zm136-5c.276 0 .5.215.5.49l.001.644c.151.088.278.214.365.366h.644a.5.5 0 01.482.412l.008.088c0 .276-.215.5-.49.5l-.644.001a1.014 1.014 0 01-.365.365l-.001.644a.5.5 0 01-.412.482L138 82.5a.506.506 0 01-.5-.505v-.629a1.005 1.005 0 01-.366-.365L136.49 81a.5.5 0 01-.482-.412L136 80.5c0-.276.215-.5.49-.5h.644c.088-.152.214-.278.366-.366v-.642a.5.5 0 01.412-.484L138 78.5zM13.75 73c.173 0 .313.134.313.307v.402a.628.628 0 01.228.228h.402c.146 0 .267.107.299.243l.008.07a.308.308 0 01-.307.313h-.402a.628.628 0 01-.228.228v.402a.312.312 0 01-.243.299l-.07.008a.314.314 0 01-.313-.303v-.406a.628.628 0 01-.228-.228h-.402a.312.312 0 01-.299-.243l-.008-.07c0-.173.134-.313.307-.313h.402a.628.628 0 01.228-.228v-.402c0-.145.107-.267.243-.299l.07-.008zm107-30.5c.173 0 .313.134.313.307v.402a.628.628 0 01.228.228h.402c.146 0 .267.107.299.243l.008.07a.308.308 0 01-.307.313h-.402a.628.628 0 01-.228.228v.402a.312.312 0 01-.243.299l-.07.008a.314.314 0 01-.313-.303v-.406a.628.628 0 01-.228-.228h-.402a.312.312 0 01-.299-.243l-.008-.07c0-.173.134-.313.307-.313h.402a.628.628 0 01.228-.228v-.402c0-.145.107-.267.243-.299l.07-.008zM20.25 38c.173 0 .313.134.313.307v.402a.628.628 0 01.228.228h.402c.146 0 .267.107.299.243l.008.07a.308.308 0 01-.307.313h-.402a.628.628 0 01-.228.228v.402a.312.312 0 01-.243.299l-.07.008a.314.314 0 01-.313-.303v-.406a.628.628 0 01-.228-.228h-.402a.312.312 0 01-.299-.243L19 39.25c0-.173.134-.313.307-.313h.402a.628.628 0 01.228-.228v-.402c0-.145.107-.267.243-.299l.07-.008zm110.25-3.5c.276 0 .5.215.5.49l.001.644c.151.088.278.214.365.366h.644a.5.5 0 01.482.412l.008.088c0 .276-.215.5-.49.5l-.644.001a1.014 1.014 0 01-.365.365l-.001.644a.5.5 0 01-.412.482l-.088.008a.506.506 0 01-.5-.505v-.629a1.005 1.005 0 01-.366-.365L128.99 37a.5.5 0 01-.482-.412l-.008-.088c0-.276.215-.5.49-.5h.644c.088-.152.214-.278.366-.366v-.642a.5.5 0 01.412-.484l.088-.008zM31 24.5c.276 0 .5.215.5.49l.001.644c.151.088.278.214.365.366h.644a.5.5 0 01.482.412L33 26.5c0 .276-.215.5-.49.5l-.644.001a1.014 1.014 0 01-.365.365l-.001.644a.5.5 0 01-.412.482L31 28.5a.506.506 0 01-.5-.505v-.629a1.005 1.005 0 01-.366-.365L29.49 27a.5.5 0 01-.482-.412L29 26.5c0-.276.215-.5.49-.5h.644c.088-.152.214-.278.366-.366v-.642a.5.5 0 01.412-.484L31 24.5zM96 19c.276 0 .5.215.5.49l.001.644c.151.088.278.214.365.366h.644a.5.5 0 01.482.412L98 21c0 .276-.215.5-.49.5l-.644.001a1.014 1.014 0 01-.365.365l-.001.644a.5.5 0 01-.412.482L96 23a.506.506 0 01-.5-.505v-.629a1.005 1.005 0 01-.366-.365l-.644-.001a.5.5 0 01-.482-.412L94 21c0-.276.215-.5.49-.5h.644c.088-.152.214-.278.366-.366v-.642a.5.5 0 01.412-.484L96 19zM64.5 0c.276 0 .5.215.5.49l.001.644c.151.088.278.214.365.366h.644a.5.5 0 01.482.412L66.5 2c0 .276-.215.5-.49.5l-.644.001a1.014 1.014 0 01-.365.365L65 3.51a.5.5 0 01-.412.482L64.5 4a.506.506 0 01-.5-.505v-.629a1.005 1.005 0 01-.366-.365L62.99 2.5a.5.5 0 01-.482-.412L62.5 2c0-.276.215-.5.49-.5h.644c.088-.152.214-.278.366-.366V.492a.5.5 0 01.412-.484L64.5 0z"
            />
            <path
                fill={vars.white}
                stroke={vars.bdlBoxBlue}
                strokeWidth={2}
                d="M30 42.99c0-.823.668-1.49 1.509-1.49H59.77c.833 0 1.788.605 2.139 1.365l3.207 6.942c.348.754-.036 1.365-.86 1.365H31.491A1.489 1.489 0 0130 49.682V42.99z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillOpacity={0.07}
                d="M31.787 44.925c0-.823.669-1.49 1.494-1.49h25.164c.825 0 1.751.62 2.07 1.385l2.87 6.9c.317.766-.097 1.387-.933 1.387H33.296a1.498 1.498 0 01-1.509-1.49v-6.692z"
            />
            <rect
                width={80}
                height={53.197}
                x={30}
                y={47.303}
                fill={vars.white}
                stroke={vars.bdlBoxBlue}
                strokeWidth={2}
                rx={1.5}
            />
            <path
                fill={vars.bdlBoxBlue}
                fillOpacity={0.07}
                d="M32 86.719c0-.827.657-1.34 1.475-1.186 0 0 3.614 1.269 23.858 1.269 12.585 0 18.165 3.312 25.334 3.312 14.499 0 23.954-4.332 23.954-4.332.762-.31 1.379.116 1.379.937v10.284c0 .827-.68 1.497-1.501 1.497H33.501A1.503 1.503 0 0132 97.003V86.719z"
            />
            <path
                fill={vars.white}
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M129.974 50.366c.661-.086.695.002.05.206L92.508 62.388c-.635.2-1.59.044-2.126-.342l-6.71-4.832c-.54-.388-.45-.772.22-.86l46.08-5.988z"
            />
            <path
                fill={vars.white}
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M130.018 50.564c.637-.197.694-.067.142.28l-36.542 23.04c-.559.353-1.076.111-1.156-.548l-1.158-9.552c-.08-.655.362-1.344 1.01-1.544l37.704-11.676z"
            />
            <path
                fill={vars.white}
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M130.09 50.702c.597-.275.621-.21.07.137L93.577 73.773c-.56.35-.82.143-.577-.475l2.216-5.645c.24-.613.924-1.335 1.518-1.608l33.354-15.343z"
            />
            <path
                fill={vars.white}
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M130.08 50.702c.603-.276.71-.123.234.347l-23.216 22.893c-.474.468-1.286.51-1.797.106L96.6 67.186c-.519-.409-.45-.964.153-1.24l33.327-15.244z"
            />
            <path
                stroke={vars.bdlBoxBlue}
                strokeDasharray={4}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M28.92 65.096c-40.64 20.09-6.817 20.357 3.439 18.837 10.256-1.521 42.431-8.461 42.743-10.048"
            />
        </g>
    </AccessibleSVG>
);

export default FolderPlane140;
